export default __webpack_public_path__ + "static/media/sneakers.73639ffd.jpg";